import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TokenStatuses } from './interfaces/token-status.interfaces';

@Component({
  selector: 'gtd-token-status',
  templateUrl: './token-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TokenStatusComponent {
  @Input() data: { status: TokenStatuses; date?: string };
  public TokenStatuses = TokenStatuses;
  public tokenStatusesLabels = {
    [TokenStatuses.EXPIRED]: $localize`:@@api_tokens.expired_status:Expired`,
    [TokenStatuses.NO_RESTRICTIONS]: $localize`:@@api_tokens.no_restrictions_status:No Restrictions`,
    [TokenStatuses.VALID_UNTIL]: $localize`:@@api_tokens.valid_until_status:Until`,
  };
}
